/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../../tslib.es6-e01eabb2.js';
import { extend } from '../../extend/index.js';
import { env } from '../../env/index.js';
import '../../extend/register/index.js';
import '../../../index-f24a9ec1.js';
import '../../../bridges/dd/index.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../bridges/windvane/index.js';
import '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridges/pangu-mini-app/index.js';
import '../../../log-aabf3a34.js';
import '../../../index-892d8eee.js';

var isAndroid = env.isAndroid, isIOS = env.isIOS, version = env.version;
/**
 * 当前菜鸟App版本，是否支持预加载穿山甲视频
 */
var cnIsSupportPreloadAdVersion = function () {
    return (isAndroid && (version === null || version === void 0 ? void 0 : version.gte('7.7.0.0'))) || isIOS;
};
// 执行预加载广告视频
var preloadAd = extend({
    web: {
        windvane: {
            cn: function (options, context) {
                context === null || context === void 0 ? void 0 : context.WVCall('CNHybridRewardedVideoAd.preloadAd', __assign({ orientation: 1, onlyWifiReload: true }, options));
            },
        },
    },
});
var cn = (function (options) {
    var success = options.success, fail = options.fail;
    if (!cnIsSupportPreloadAdVersion()) {
        fail({
            errMsg: '当前菜鸟App版本，不支持preloadAdVideo API',
        });
        return;
    }
    preloadAd(options).then(success).catch(fail);
});

export { cn as default };
